import React from 'react';
import { motion } from 'framer-motion';

export default function Impact() {
  const metrics = [
    { value: '2.4M+', label: 'Plastic Bottles Averted' },
    { value: '150k', label: 'Gallons of Water Saved' },
    { value: '100%', label: 'Carbon Neutral Shipping' }
  ];

  return (
    <section className="py-20 bg-teal-900 text-white" id="impact">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">Our Collective Impact</h2>
          <p className="text-teal-200 text-lg max-w-2xl mx-auto">
            Every refill counts. Together with our community, we're making a measurable difference in reducing single-use plastics.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-teal-800">
          {metrics.map((metric, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="py-8 md:py-0 flex flex-col items-center justify-center text-center"
            >
              <div className="text-5xl md:text-6xl font-black mb-2 tracking-tighter text-teal-300">
                {metric.value}
              </div>
              <div className="text-teal-100 font-medium uppercase tracking-widest text-sm">
                {metric.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}